module.exports = __webpack_public_path__ + "img/rule.8ae71bc8.png";